import React from "react";
import { useFormik } from "formik";
import Button from "../../../components/Button";
import axios from "axios";
import { getStageScreen, setLoading } from "../../../../../redux";
import { useDispatch, useSelector } from "react-redux";
import { showNextBtnByUrl, showPrevBtnByUrl, getPrevAndNextRoute } from "utils";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";

function Consortium() {
  const dispatch = useDispatch();

  const history = useHistory();
  const { kycStatus, kycPageName } = useSelector((state) => state.navigation);
  const getApiUrl = () => {
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    let API_URL = "";
    if (portal_domain) {
      API_URL = portal_domain.substring(0, portal_domain.length - 1);
    }
    return API_URL;
  };

  const getApiHeader = () => {
    const token = window.sessionStorage.getItem("token");
    let headers = "";
    if (token) {
      headers = {
        headers: {
          Authorization: `Basic ${token}`,
        },
      };
    }
    return headers;
  };

  const validationSchema = Yup.object({
    cs_d_slab: Yup.number().required("Required"),
    cs_d_min: Yup.number().required("Required"),
    cs_ds_slab: Yup.number().required("Required"),
    cs_ds_min: Yup.number().required("Required"),
  });

  const formik = useFormik({
    initialValues: {
      cs_d_slab: "",
      cs_d_min: "",
      cs_d_trans_type: "One Side", // Default selected value
      cs_ds_slab: "",
      cs_ds_min: "",
      cs_ds_trans_type: "One Side", // Default selected value
      ds_fut_slab: "",
      ds_fut_min: "",
      ds_fut_trans_type: "One Side", // Default selected value
      ds_op_slab: "",
      ds_op_min: "",
      ds_op_trans_type: "One Side", // Default selected value
      cds_fut_slab: "",
      cds_fut_min: "",
      cds_fut_trans_type: "One Side", // Default selected value
      cds_op_slab: "",
      cds_op_min: "",
      cds_op_trans_type: "One Side", // Default selected value
      mf_fut_slab: "",
      mf_fut_min: "",
      mf_op_slab: "",
      mf_op_min: "",
      cd_fut_slab: "",
      cd_fut_min: "",
      cd_fut_trans_type: "One Side", // Default selected value
      cd_op_slab: "",
      cd_op_min: "",
      cd_op_trans_type: "One Side", // Default selected value
    },
    validationSchema,
    onSubmit: async (values) => {
      dispatch(setLoading(true));
      // Convert values to FormData
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key]);
      });

      try {
        // Assuming getApiUrl() and getApiHeader() are functions that return your API's URL and headers respectively
        const response = await axios.post(
          getApiUrl() +
          "/api/method/kyc_customizations.apis.client_tariff_scheme.client_tariff_scheme.update_client_tariff_scheme",
          formData,
          getApiHeader()
        );
        console.log(response.data);
        dispatch(getStageScreen());
        dispatch(setLoading(false));
        // Handle success
      } catch (error) {
        console.error(
          "There was an error submitting the form:",
          error.response
        );
        dispatch(setLoading(false));
        // Handle error
      }
    },
  });

  return (
    <div
      className="col-md-12 mt-4 "
      style={{ fontSize: 14 }}
    >
      <form onSubmit={formik.handleSubmit}>
        <h4>CASH SEGMENT</h4>
        <table className="table">
          <thead>
            <tr>
              <th>Brokerage Slab</th>
              <th>Slab %</th>
              <th>Minimum Paise</th>
              <th>One Side</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Delivery Based</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  style={{ width: "50px" }}
                  id="cs_d_slab"
                  {...formik.getFieldProps("cs_d_slab")}
                />
                {formik.touched.cs_d_slab && formik.errors.cs_d_slab ? (
                  <div className="text-danger">{formik.errors.cs_d_slab}</div>
                ) : null}
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cs_d_min"
                  style={{ width: "50px" }}
                  {...formik.getFieldProps("cs_d_min")}
                />

                {formik.touched.cs_d_min && formik.errors.cs_d_min ? (
                  <div className="text-danger">{formik.errors.cs_d_min}</div>
                ) : null}
              </td>
              <td>
                <select
                  id="cs_d_trans_type"
                  className="form-select"
                  {...formik.getFieldProps("cs_d_trans_type")}
                  style={{ width: "200px" }}
                >
                  <option>One Side</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>Daily Square up</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cs_ds_slab"
                  {...formik.getFieldProps("cs_ds_slab")}
                  style={{ width: "50px" }}
                />
                {formik.touched.cs_ds_slab && formik.errors.cs_ds_slab ? (
                  <div className="text-danger">{formik.errors.cs_ds_slab}</div>
                ) : null}
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cs_ds_min"
                  {...formik.getFieldProps("cs_ds_min")}
                  style={{ width: "50px" }}
                />
                {formik.touched.cs_ds_min && formik.errors.cs_ds_min ? (
                  <div className="text-danger">{formik.errors.cs_ds_min}</div>
                ) : null}
              </td>
              <td>
                <select
                  id="cs_ds_trans_type"
                  className="form-select"
                  {...formik.getFieldProps("cs_ds_trans_type")}
                  style={{ width: "200px" }}
                >
                  <option>One Side</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <h4>DERIVATIVES SEGMENT</h4>
        <table className="table">
          <thead>
            <tr>
              <th>Brokerage Slab</th>
              <th>Slab %</th>
              <th>Minimum Paise / Per Lot</th>
              <th>One Side</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Future</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="ds_fut_slab"
                  {...formik.getFieldProps("ds_fut_slab")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="ds_fut_min"
                  {...formik.getFieldProps("ds_fut_min")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <select
                  className="form-select"
                  id="ds_fut_trans_type"
                  {...formik.getFieldProps("ds_fut_trans_type")}
                  style={{ width: "200px" }}
                >
                  <option>One Side</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>Option (Per Lot)</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="ds_op_slab"
                  {...formik.getFieldProps("ds_op_slab")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="ds_op_min"
                  {...formik.getFieldProps("ds_op_min")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <select
                  className="form-select"
                  id="ds_op_trans_type"
                  {...formik.getFieldProps("ds_op_trans_type")}
                  style={{ width: "200px" }}
                >
                  <option>One Side</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <h4>CURRENCY DERIVATIVES SEGMENT</h4>
        <table className="table">
          <thead>
            <tr>
              <th>Brokerage Slab</th>
              <th>Slab %</th>
              <th>Minimum Paise / Per Lot</th>
              <th>One Side</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Future</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cds_fut_slab"
                  {...formik.getFieldProps("cds_fut_slab")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cds_fut_min"
                  {...formik.getFieldProps("cds_fut_min")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <select
                  className="form-select"
                  id="cds_fut_trans_type"
                  {...formik.getFieldProps("cds_fut_trans_type")}
                  style={{ width: "200px" }}
                >
                  <option>One Side</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>Option (Per Lot)</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cds_op_slab"
                  {...formik.getFieldProps("cds_op_slab")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cds_op_min"
                  {...formik.getFieldProps("cds_op_min")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <select
                  className="form-select"
                  id="cds_op_trans_type"
                  {...formik.getFieldProps("cds_op_trans_type")}
                  style={{ width: "200px" }}
                >
                  <option>One Side</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <h4>MUTUAL FUND</h4>
        <table className="table">
          <thead>
            <tr>
              <th>Brokerage Slab</th>
              <th>Slab %</th>
              <th>Minimum Paise</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Future</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="mf_fut_slab"
                  {...formik.getFieldProps("mf_fut_slab")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="mf_fut_min"
                  {...formik.getFieldProps("mf_fut_min")}
                  style={{ width: "50px" }}
                />
              </td>
            </tr>
            <tr>
              <th>Option (Per Lot)</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="mf_op_slab"
                  {...formik.getFieldProps("mf_op_slab")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="mf_op_min"
                  {...formik.getFieldProps("mf_op_min")}
                  style={{ width: "50px" }}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <h4>COMMODITIES DERIVATIVES</h4>
        <table className="table">
          <thead>
            <tr>
              <th>Brokerage Slab</th>
              <th>Slab %</th>
              <th>Minimum Paise / Per Lot</th>
              <th>One Side </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Future</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cd_fut_slab"
                  {...formik.getFieldProps("cd_fut_slab")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cd_fut_min"
                  {...formik.getFieldProps("cd_fut_min")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <select
                  className="form-select"
                  id="cd_fut_trans_type"
                  {...formik.getFieldProps("cd_fut_trans_type")}
                  style={{ width: "200px" }}
                >
                  <option>One Side</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>Option (Per Lot)</th>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cd_op_slab"
                  {...formik.getFieldProps("cd_op_slab")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  id="cd_op_min"
                  {...formik.getFieldProps("cd_op_min")}
                  style={{ width: "50px" }}
                />
              </td>
              <td>
                <select
                  className="form-select"
                  id="cd_op_trans_type"
                  {...formik.getFieldProps("cd_op_trans_type")}
                  style={{ width: "200px" }}
                >
                  <option>One Side</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex mt-4">
          {showPrevBtnByUrl(
            history.location.pathname,
            kycStatus,
            kycPageName
          ) && (
              <Button
                title="Previous"
                type="button"
                className="mx-1"
                handleClick={() => {
                  const route = getPrevAndNextRoute(
                    history.location.pathname.slice(1),
                    kycPageName
                  );
                  history.push(route.prev);
                }}
              />
            )}
          <Button
            title="Submit"
            className="mx-1"
          />
          {showNextBtnByUrl(
            history.location.pathname,
            kycStatus,
            kycPageName
          ) && (
              <Button
                title="Next"
                type="button"
                className="mx-1"
                handleClick={() => {
                  const route = getPrevAndNextRoute(
                    history.location.pathname.slice(1),
                    kycPageName
                  );
                  history.push(route.next);
                }}
              />
            )}
        </div>
        {/* <Button
                    title="Submit"
                    disabled={false}
                /> */}
      </form>
    </div>
  );
}

export default Consortium;
